import { createStore, applyMiddleware, compose } from "redux";
import { fromJS } from "immutable";
import createSagaMiddleware from "redux-saga";

import { routerMiddleware } from "react-router-redux";

import rootReducer from "./reducers";
import rootSaga from "./sagas";
import history from "./utility/history";

const sagaMiddleware = createSagaMiddleware();

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

//The initial state. Optional parameter, usually used to hydrate a previously serialized user session.
export default function configureStore(initialState) {
  const middlewares = [sagaMiddleware, middleware];

  const enhancers = [applyMiddleware(...middlewares)];

  const composeEnhancers =
    typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  /* eslint-enable */

  const store = createStore(
    rootReducer,
    fromJS(initialState),
    composeEnhancers(...enhancers)
  );

  sagaMiddleware.run(rootSaga);

  return store;
}



// WEBPACK FOOTER //
// ./src/store.js